module.exports = __webpack_public_path__ + "img/no-mobile-phones.46045698.png";